import { Tooltip } from '@paysera/ui';
import QuestionIcon from '@app/components/icons/QuestionIcon';
const ToolTipContent = ({ text }) => (<div style={{ maxWidth: '250px', wordBreak: 'break-word' }}>{text}</div>);
const PortfolioSection = ({ title, items }) => (<div className="py-4 md:py-8 flex flex-col gap-2 md:gap-3">
        <div className="h-4 flex flex-col justify-center">
            <div className="inline-flex items-center gap-1">
                <div className="label-s text-neutral-primary-initial font-medium">{title}</div>
            </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-3 md:gap-4">
            {items.map((item) => (<div key={item.label} className="flex flex-col gap-0.5">
                    <div className="inline-flex items-center gap-1 flex-wrap content-center">
                        <div className="label-s text-neutral-secondary-initial">{item.label}</div>
                        {(item === null || item === void 0 ? void 0 : item.tooltipText) && (<Tooltip description={<ToolTipContent text={item.tooltipText}/>} position="right" alignment="end">
                                <div className="w-4 h-4">
                                    <QuestionIcon className="text-neutral-secondary-initial"/>
                                </div>
                            </Tooltip>)}
                    </div>
                    <div className="body-s font-semibold text-neutral-primary-initial">{item.value}</div>
                </div>))}
        </div>
    </div>);
export default PortfolioSection;
